/**
 * Toyplein Gift Wrap Handler
 * Adds/removes the hidden gift wrap product (€2.95) from cart
 * when the checkbox on the product page is toggled.
 *
 * SETUP: Replace GIFT_WRAP_VARIANT_ID with the actual variant ID
 * from setup_store.py output or Shopify Admin.
 */

(function () {
  // === CONFIGURATION ===
  // Set this after running setup_store.py or checking Shopify Admin
  const GIFT_WRAP_VARIANT_ID = 58667031298383;

  if (!GIFT_WRAP_VARIANT_ID) {
    console.warn('Toyplein: Gift wrap variant ID not configured. Set GIFT_WRAP_VARIANT_ID in toyplein-gift-wrap.js');
    return;
  }

  const checkbox = document.getElementById('toyplein-gift-wrap-toggle');
  if (!checkbox) return;

  checkbox.addEventListener('change', async function () {
    if (this.checked) {
      // Add gift wrap to cart
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: GIFT_WRAP_VARIANT_ID, quantity: 1 }],
          }),
        });
      } catch (e) {
        console.error('Failed to add gift wrap:', e);
        this.checked = false;
      }
    } else {
      // Remove gift wrap from cart
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: GIFT_WRAP_VARIANT_ID.toString(),
            quantity: 0,
          }),
        });
      } catch (e) {
        console.error('Failed to remove gift wrap:', e);
        this.checked = true;
      }
    }
  });
})();
